module.exports = __webpack_public_path__ + "img/recent-work-04.971ba2d9.jpg";